/**
 * Converts the given amount from minor units to major units (for example cents to dollars, groszy to złoty).
 *
 * @param amountInMinorUnits The amount to convert, in minor units.
 * @returns The converted amount in major units.
 */
export const convertToMajorUnit = (amountInMinorUnits: number): number => amountInMinorUnits / 100
